import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';

interface ClientPortalTaskFormButtonsProps {
  onCancelAction: () => void;
}

const ClientPortalTaskFormButtons = ({ onCancelAction }: ClientPortalTaskFormButtonsProps) => {
  const { submitForm, isLoadingArtifact, isSubmitEnabled } = useFormContext();

  return (
    <Grid container direction="row" justifyContent="flex-end" gap={1}>
      <Button variant="outlined" onClick={onCancelAction}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={() => (submitForm ? submitForm() : null)}
        disabled={!isSubmitEnabled || isLoadingArtifact}
      >
        Create task
      </Button>
    </Grid>
  );
};

export default ClientPortalTaskFormButtons;
